import css from "../../pages/BrakesPage/BrakesPage.module.css";
export default function Final() {
  return (
    <div className={css.finalText}>
      <h2>
        Proactive maintenance prevents costly repairs, improves stopping power,
        and enhances safety. In hilly, stop-and-go traffic, brakes can wear
        fastererr on the side of more frequent checks!
      </h2>
    </div>
  );
}
